import { Field, Checkbox, TextOutput, TextInput } from 'Components/Core';
import { FieldSet } from 'Components/Layout';
import { useSelector } from 'react-redux';
import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { valueOrDefault } from 'Lib/Any';
import { pipe } from 'rxjs';
import { ICoreFieldProps } from './types';

interface IExcludedMaterialProps extends ICoreFieldProps {
  readOnlyDefaultText?: string;
  descriptionAlwaysVisible?: boolean;
}

let ExcludedMaterial: React.FC<IExcludedMaterialProps> = ({
  createWorksheetSelector,
  editable = false,
  visible = true,
  readOnlyDefaultText = 'No',
  descriptionAlwaysVisible = false,
  appendNamePrefix,
}) => {
  const excludedMaterial = useSelector(
    pipe(createWorksheetSelector!(`${appendNamePrefix}.ExcludedMaterial`), valueOrDefault(false))
  );

  const excludedMaterialDescription = useSelector(
    createWorksheetSelector!(`${appendNamePrefix}.ExcludedMaterialDescription`)
  );

  if (!visible) {
    return null;
  }
  return (
    <NamePrefixModifier appendNamePrefix={appendNamePrefix}>
      {editable ? (
        <FieldSet>
          <Field
            emph
            input={<Checkbox />}
            name="ExcludedMaterial"
            label="Material Excluded"
            confirm={({ value }) => value === false && excludedMaterialDescription}
            confirmText="The Excluded Material Description field will be cleared."
            confirmButtonText="Confirm"
          />
          <Field
            input={<TextInput />}
            name="ExcludedMaterialDescription"
            label="Excluded Material Description"
            maxLength={100}
            visible={descriptionAlwaysVisible || excludedMaterial}
            disabled={!excludedMaterial}
          />
        </FieldSet>
      ) : (
        <Field
          input={<TextOutput />}
          label="Material Excluded"
          name="ExcludedMaterialDescription"
          value={excludedMaterial ? undefined : readOnlyDefaultText}
        />
      )}
    </NamePrefixModifier>
  );
};

ExcludedMaterial = withInjectedProps(ExcludedMaterial);

export { ExcludedMaterial };
